import { Component, Inject, ViewChild, inject } from "@angular/core";
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Store } from "@ngxs/store";

import { Appointment, Family, Time, TeamMember, SaveTeamMemberWorkTime, DateUtil, TeamMemberWorkTime, ClearPageOfFamilies, GetPageOfFamilies, SaveAppointment, ServiceLevelService, ServiceLevelServices, GetCandidateAppointments, CandidateSet, ChecklistTemplate, ChecklistItem, AppointmentChecklist, FamilyStore, FamilyPage, SchedulingStateStore, PractitionerGroupEntity } from 'huddyapi';
import { DesktopErrorHandler } from "../../services/errorHandler.service";
import { CalendarBackEndPair } from "../../todo/calendar-view/calendar-view";
import { CommunityConfigService, UserTeam } from '../../services/community-config.service';
import { addDays, addHours, addMinutes, differenceInBusinessDays, differenceInMinutes, differenceInSeconds, endOfDay, format, isBefore, startOfDay, startOfHour } from "date-fns";
import { MatTable } from "@angular/material/table";
import { Util } from "../util";


@Component({
  selector: 'edit-calendar-event-dialog',
  templateUrl: 'edit-calendar-event-dialog.component.html',
  styleUrls: ["./edit-calendar-event-dialog.component.scss"],
  providers: [FamilyStore, SchedulingStateStore]
})
export class EditCalendarEventDialog  {
  readonly familyStore = inject(FamilyStore);
  readonly schedulingStateStore = inject(SchedulingStateStore);
  eventTypes : string[] = ['Appointment', 'Time off'];
  hours : number[] = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  minutes : number[] = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
  ampm : string[] = ['am', 'pm'];
  appointmentStatuses : string[] = ['REQUESTED', 'TO_BE_SCHEDULED', 'SCHEDULED', 'OCCURRED', 'FOLLOWED_UP', 'COMPLETED', 'DENIED'];
  worktimeStatuses : string[] = [ 'REQUESTED', 'SCHEDULED', 'DENIED'];
  displayChecklistColumns : string[] ;
  activeStatuses : string[] = [].concat(this.appointmentStatuses);
  shadowStartDate : Date ;
  shadowEndDate : Date ;
  eventMode : string = 'Add';
  currentTeam : UserTeam;
  currentMembers : TeamMember[];
  panel : number = 0;
  teamCapabilities : ServiceLevelService[];
  families : Family[];
  userTeamMember : TeamMember;
  serviceLevels : ServiceLevelServices[];
  serviceLevelServices : ServiceLevelService[];
  family : Family;
  candidates : CandidateSet[] = [];
  cachedEvents: CachedEvent[] = [];
  tabIndex : number = 0;
  checklistTemplates : ChecklistTemplate[];
  displayColumns = ['from', 'to'];
  currentChecklistItems : ChecklistItem[] = [];
  checklistItemRows: UntypedFormArray = this.formBuilder.array([]);

  @ViewChild(MatTable) table: MatTable<any>;
  static BASICS_PANEL : number = 0;
  static CANDIDATES_PANEL : number = 1;
  static PROGRESS_PANEL : number = 2;
  static NOTES_PANEL : number = 3;



  public minDate = new Time().momentVal;
  public maxDate= new Time().momentVal;
  eventForm = this.formBuilder.group({
    eventType : ['', [Validators.required]],
    startDt: ['', [Validators.required]],
    endDt:  ['', [Validators.required]],
    status : ['', [Validators.required]],
    allDay : ['', []],
    description : ['', [Validators.required]],
    notes : ['', []],
    team : ['', []],
    teamMember: ['', []],
    servicesRequired : [[], []],
    familyIdentifier : ['', []],
    familySearchIdentifier : ['', []],
    checklistTemplate : [{}, []],
    checklistItems : this.checklistItemRows
});

  constructor(
    public dialogRef: MatDialogRef<EditCalendarEventDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder : UntypedFormBuilder,
    public store : Store,
    public errorHandler: DesktopErrorHandler
  )
  {
    const pair : CalendarBackEndPair = data.pair;
    this.checklistTemplates = [].concat(pair.checklistTemplates);
    this.currentTeam = data.currentTeam;


    this.currentMembers = data.currentMembers;
    this.serviceLevels = data.serviceLevels;
    console.log('entering calendar event dialog', data, this.currentMembers);
    const now : Date = startOfHour(new Date());
    const nextHour : Date = addHours(now, 1);
    const followingHour : Date = addHours(now, 2);
    this.eventMode = pair.action;
    let teamMember : TeamMember = null;
    if (pair.username) {
     this.userTeamMember = (this.currentMembers) ? this.currentMembers.find(tm => tm.email === pair.username) : undefined;
     teamMember = this.userTeamMember;
    }
   this.teamCapabilities = [];
   if (this.currentMembers) {
    for (let teamMember of this.currentMembers) {
      this.teamCapabilities = this.teamCapabilities.concat(teamMember.capabilities);
    }
    this.teamCapabilities = [...new Set(this.teamCapabilities)];
  }

  // console.log('team capabilities isCoordinator()', this.currentMembers, this.teamCapabilities, teamMember, this.userTeamMember, this.isCoordinator());
  this.displayChecklistColumns =   ['item', 'workerScore', 'coordScore']  ;
    console.log('constructor', pair.backendEvent);
    if (pair.backendEvent) {
      if (data.appointment) {
        if (data.family) {
            this.family = data.family;
            console.log('Setting family', this.family);
        } else if (data.appointment.familyIdentifier) {
          this.eventForm.controls.familySearchIdentifier.setValue(data.appointment.familyIdentifier);
          this.getPageOfFamilies(undefined, true);
        }
      }

      teamMember = this.currentMembers.find(member => pair.backendEvent?.teamMembers[0].id === member.id);
      let status : string = pair.backendEvent.status;
      if (status === 'TO_BE_SCHEDULED') {
        status = 'SCHEDULED';
      }
      this.cachedEvents.push({
        eventType : pair.backendEvent.sourceType === 'Appointment' ? 'Appointment' : 'Time off',
        appointment : {
          id : data.appointment ? data.appointment.id :  undefined,
          familyId : data.appointment ? data.appointment.familyId : undefined,
          familyPrimary: data.appointment ? data.appointment.familyPrimary : undefined,
          startDateTime: pair.backendEvent ? pair.backendEvent.start.getTime() / 1000 : nextHour.getTime() / 1000,
          endDateTime:   pair.backendEvent && pair.backendEvent.end ?  pair.backendEvent.end.getTime()  / 1000 : followingHour.getTime() / 1000,
          status : status,
          sequenceNum : data.appointment.sequenceNum,
          description:  data.appointment ? data.appointment.description : pair.backendEvent.text ?? '',
          notes: data.appointment ? data.appointment.notes :  '',
          teamMembers: [teamMember],
          sourceTemplateIds : data.appointment ? data.appointment.sourceTemplateIds :  [],
          requiredServices: data.appointment ? data.appointment.requiredServices : [],
          familyIdentifier :  data.appointment ?  data.appointment.familyIdentifier : '',
          memberCompletionScore: data.appointment ? data.appointment.memberCompletionScore : 0,
          coordinatorCompletionScore: data.appointment ? data.appointment.coordinatorCompletionScore : 0,
          checklist :   data.appointment.checklist ?  data.appointment.checklist : ({
            name : '',
            appointmentId: this.data.appointmentId,
            sourceTemplateId : 0,
            workerScore : 0,
            managerScore: 0,
            checklistItems: []
          }),
        },
        allDay : pair.backendEvent.allDay ?? false,
      });


      // console.log('cachedEvents[0]', this.cachedEvents[0]);
    } else {
      // console.log(teamMember.id);
      if (data.family) {
        this.family =data.family;
      }
      this.cachedEvents.push({
        eventType : 'Appointment',
        appointment : {
          familyId : this.family ? this.family.id : undefined,
          familyPrimary: this.family ? this.family.namedPrimary : undefined,
          startDateTime:  nextHour.getTime() / 1000,
          endDateTime:  followingHour.getTime() /1000,
          status: 'REQUESTED',
          sequenceNum : undefined,
          description: '',
          notes: '',
          teamMembers: [teamMember],
          sourceTemplateIds : [],
          requiredServices: [],
          familyIdentifier: '',
          memberCompletionScore:  0,
          coordinatorCompletionScore:  0,
          checklist : ({
            name : '',
            id: null,
            appointmentId: this.data.appointmentId,
            sourceTemplateIds : [],
            workerScore : 0,
            managerScore: 0,
            checklistItems: []
          })
        },
        allDay: false
      });
    }
    this.setFromCache(this.cachedEvents[0]);
    if (pair.backendEvent) {
      console.log('calling getPageOfFamilies', this.eventForm.value.familySearchIdentifier);
      this.getPageOfFamilies(undefined, true);
    }
    console.log('canReschedule', this.canReschedule(), this.isRequestedStatus());
  }

  getTeams() : PractitionerGroupEntity[] {
    return CommunityConfigService.fullTeams;
  }


  setFromCache(cachedEvent : CachedEvent) {

    const appointment : Appointment = cachedEvent.appointment;
     console.log('setFromCache', appointment);
    let familySearchIdentifier : string = '';
    if (this.family) {
      familySearchIdentifier = this.family.identifier + ' ' +
      this.family.namedPrimary;
      if (this.family.serviceLevel) {
        familySearchIdentifier = familySearchIdentifier +  + ' (' + this.family.serviceLevel + ')';
      }
    } else if (appointment.id || appointment.familyIdentifier) {
      familySearchIdentifier = appointment.familyIdentifier;
    }
    this.checklistItemRows = this.formBuilder.array([]);
    this.currentChecklistItems = [];
    if (cachedEvent.appointment && cachedEvent.appointment.checklist) {
      for (let cli of cachedEvent.appointment.checklist.checklistItems) {
        this.currentChecklistItems.push(cli);
        this.addChecklistItemRow(cli);
      }

    }
    console.log('checklistItemRows', this.currentMembers, appointment);
    let appointmentTeamMemberIds : number[] = appointment.teamMembers.map(t => t.id);
    let teamMembers : TeamMember[] =  this.currentMembers.filter(m => appointmentTeamMemberIds.indexOf(m.id) > -1);

    const practitionerGroup = this.getTeams().find(t => t.id == teamMembers[0].groupId);
    this.eventForm.setValue({
      eventType : cachedEvent.eventType,
      startDt:  new Date(appointment.startDateTime * 1000),
      endDt:  new Date(appointment.endDateTime * 1000),
      allDay: cachedEvent.allDay,
      status: appointment.status,
      description: appointment.description,
      notes: appointment.notes ? appointment.notes : '',
      team : practitionerGroup,
      teamMembers :  teamMembers,
      servicesRequired: appointment.requiredServices.map(skill => skill.name),
      familyIdentifier: appointment.familyIdentifier,
      familySearchIdentifier : familySearchIdentifier,
      checklistTemplate : null,
      checklistItems: []
    });
    // console.log('setFromCache 2', appointment, this.eventForm.value.familySearchIdentifier, familySearchIdentifier, this.family);
    if (this.eventForm.value.eventType === 'APPOINTMENT') {
      if (this.eventMode != 'Edit') {
        this.eventForm.controls.familySearchIdentifier.enable();
      }
      if (!this.canReschedule()) {
        this.eventForm.controls.startDt.disable();
        this.eventForm.controls.endDt.disable();
      }
    }

    this.shadowStartDate = this.eventForm.value.startDt;
    this.shadowEndDate = this.eventForm.value.endDt;
    this.onEventTypeChanged(undefined);
  }

  sanitizeIdentifier(identifier : string, identifier2 : string) : string {
    return Util.sanitizeIdentifier(identifier, identifier2);
  }

  sanitizeNamedPrimary(familyIdentifier : string, namedPrimary : string) {
    console.log('sanitizeNamedPrimary', familyIdentifier,namedPrimary);
     if (namedPrimary.length > familyIdentifier.length) {
      return  this.sanitizeIdentifier(familyIdentifier, familyIdentifier) + namedPrimary.substring(familyIdentifier.length);
     }
     return namedPrimary;
  }

  ngOnInit(): void {

  }





  resetTimes(changed : string, event : any) {
    console.log(changed, event.value);
  }

  getTeam() : PractitionerGroupEntity {
    if (this.eventForm.value.team) {
      return this.eventForm.value.team;
    }
    return undefined;
  }

  getCapableTeamMembers() : TeamMember[] {
    const team : PractitionerGroupEntity  = this.getTeam();
    const capabilities : string[] = this.eventForm.value.servicesRequired;

    if (capabilities && capabilities.length > 0) {
      // console.log(team.teamMembers, capabilities);
      return team.teamMembers.filter(tm => tm.capabilities.find(sls =>capabilities.find(c => c == sls.name)));
    } else {
      return team.teamMembers;
    }
  }


  handleDateChanged(changed : string) {
    let start : Date= this.eventForm.value.startDt;
    let end : Date = this.eventForm.value.endDt;
    let allDay : boolean = this.eventForm.value.allDay;
    let oldDiff =  differenceInMinutes(this.shadowEndDate, this.shadowStartDate);
    // console.log('startDateClosed', this.eventForm.value.startDt,  this.eventForm.value.endDt, oldDiff);

    if (allDay) {
      start = startOfDay(start);
      end = endOfDay(end);
      this.eventForm.controls.startDt.setValue(start);
      this.eventForm.controls.endDt.setValue(end);
      if (isBefore(end, start)) {
        oldDiff = differenceInBusinessDays(this.shadowEndDate, this.shadowStartDate);
        if (changed === 'start') {
          end = endOfDay(addDays(start, oldDiff));
          this.eventForm.controls.endDt.setValue(end);
        } else {
          start = startOfDay(addDays(end, -oldDiff));
          this.eventForm.controls.startDt.setValue(start);
        }
      }
    }
    else if (isBefore(end, start)) {
      if (changed === 'start') {
        end = addMinutes(start, oldDiff);
        this.eventForm.controls.endDt.setValue(end);
      } else {
        start = addMinutes(end, -oldDiff);
        this.eventForm.controls.startDt.setValue(start);
      }
    }
    this.shadowEndDate = end;
    this.shadowStartDate = start;
  }


  isFormValid() {
    // if (new Date().getTime() % 5 == 0) {
    //   console.log('isFormValid', this.eventForm.invalid, this.family, this.eventForm);
    // }
    return !this.eventForm.invalid && (this.eventForm.value.eventType.toUpperCase() != 'APPOINTMENT' || this.family) && (this.eventForm.value.eventType.toUpperCase() != 'APPOINTMENT' || this.family.status === 'RECRUITED' || this.eventForm.value.teamMember);
  }

  onSubmitForm(eventForm) {
   this.save();
  }

  close() {
      this.dialogRef.close();
  }

  isRequest() : boolean {
    return this.eventMode === 'Request';
  }

  canEditProtocol() : boolean {
    return false;
  }



  isScheduled() : boolean {
    return this.eventForm.value.status === 'SCHEDULED';
  }

  isRequestedStatus() : boolean {
    return this.eventForm.value.status === 'REQUESTED';
  }

  hasOccurred() : boolean {
    return this.eventForm.value.status === 'OCCURRED';
  }

  getAdjustedEpochSecs(date : Date) {
    return (date.getTime() / 1000) - (60 * date.getTimezoneOffset());
  }

  save() {
    let start : Date = this.eventForm.value.startDt;
    let end : Date = this.eventForm.value.endDt ;
    if (this.isAppointment()) {
      const startSecs = this.getAdjustedEpochSecs(start);
      const endSecs = this.getAdjustedEpochSecs(end);
      console.log('save', this.family);
      const serviceLevelServices : ServiceLevelServices = this.getServiceLevel(this.family.serviceLevel);

      const servicesRequired = this.eventForm.value.servicesRequired;
      let teamMembers = this.currentMembers.filter(tm => tm.id == this.eventForm.value.teamMember.id)
      const appointment : Appointment = {
        id : this.data.appointment ? this.data.appointment.id ? this.data.appointment.id : undefined : undefined,
        familyId : this.family.id,
        familyIdentifier : this.family.identifier,
        familyPrimary : this.family.namedPrimary,
        startDateTime : startSecs,
        endDateTime : endSecs,
        sequenceNum : this.data.appointment ? this.data.appointment.sequenceNum : undefined,
        teamMembers : teamMembers,
        description : this.eventForm.value.description,
        sourceTemplateIds :  this.data.appointment ? this.data.appointment.sourceTemplateIds : undefined,
        notes : this.eventForm.value.notes,
        status : this.eventForm.value.status,
        memberCompletionScore: this.getTotalScore(),
        coordinatorCompletionScore: this.getCoordTotalScore(),
        requiredServices : servicesRequired.map(s => serviceLevelServices.services.find(sls => sls.name === s)),
        checklist: this.buildChecklistToSave(),
        mergedFrom: this.data.appointment ? this.data.appointment.mergedFrom : undefined
     };

     console.log('dispatching', appointment);
     this.store.dispatch(new SaveAppointment(appointment)).subscribe(t => {
       this.close();
     });
    } else {
      console.log('entering save work times section', this.isAppointment());
      let startEpochDay : number = DateUtil.toEpochDayFromDateWithTZAdjustment(start);
      let endEpochDay : number = DateUtil.toEpochDayFromDateWithTZAdjustment(end);
      let startTimeSecs : number = differenceInSeconds(start, startOfDay(start));
      let endTimeSecs : number = differenceInSeconds(end, startOfDay(end));

      const utcTime : number = end.getTime();
      const localTime : number = utcTime - (60000 * end.getTimezoneOffset());

      console.log('save', startEpochDay, endEpochDay,   Math.floor(localTime/8.64e7), localTime, end.getTimezoneOffset());
      const worktimeStatus = this.eventForm.value.status;
      const workTimes : TeamMemberWorkTime[] = [{
        id : (this.data.pair.backendEvent ? this.data.pair.backendEvent.id : undefined),
        teamMemberId : this.eventForm.value.teamMember.id,
        epochDay : startEpochDay,
        endDay : endEpochDay,
        allDay : this.eventForm.value.allDay,
        description : this.eventForm.value.description,
        startTimeSecs : startTimeSecs,
        endTimeSecs : endTimeSecs,
        workTimeStatus : worktimeStatus
      }];
      console.log('firing save work times section', this.isAppointment());
      let evt : SaveTeamMemberWorkTime = new SaveTeamMemberWorkTime({
        workingTime: workTimes
      });
      console.log('dispatching', evt);
      this.store.dispatch(evt).subscribe(t => {
        this.close();
      });
    }


  }

  buildChecklistToSave() : AppointmentChecklist {
    let source : AppointmentChecklist = this.data.appointment ?  this.data.appointment.checklist : undefined;
    let ret : AppointmentChecklist = {
      id : source ? source.id : undefined,
      name : source ? source.name :  'New checklist',
      appointmentId : source ? source.appointmentId : undefined,
      sourceTemplateIds : source ? [].concat(source.sourceTemplateIds) : [],
      workerScore : this.getTotalScore(),
      managerScore :this.getCoordTotalScore(),
      checklistItems : this.checklistItems.map(cli => (
        {
        id : cli.value.id,
        checklistId : source ? source.id : undefined,
        serviceId : cli.value.service,
        item : cli.value.item,
        required:  cli.value.required,
        workerScore : cli.value.workerScore,
        managerScore : cli.value.coordScore,
        workerNotes : cli.value.workerNotes,
        managerNotes : cli.value.coordNotes,
        sourceCTIId : cli.value.sourceCTIId
      }))
    };
    return ret;
  }

  isAppointment() : boolean {
    return this.eventForm.value.eventType === 'Appointment';
  }



  onEventTypeChanged(eventType : string) {

    if (this.eventForm.value.eventType === 'Appointment') {
      this.activeStatuses = [].concat(this.appointmentStatuses);
    } else {
      this.activeStatuses = [].concat(this.worktimeStatuses);
    }

    if (this.activeStatuses.indexOf(this.eventForm.value.status) === -1) {
      this.eventForm.controls.status.setValue('REQUESTED');
    }

  }

  familySelected($event) {
   // console.log('enter family selected', this.family, this.getServiceLevel(this.family.serviceLevel));
    this.eventForm.controls.familyIdentifier.setValue($event.option.value);
    this.family = this.families.find(family => family.identifier === $event.option.value);
    const serviceLevelServices : ServiceLevelServices = this.getServiceLevel(this.family.serviceLevel);
    this.eventForm.controls.familySearchIdentifier.setValue(this.family.identifier + ' ' +
    this.family.namedPrimary + ' (' + this.family.serviceLevel + ')');
    this.setServices();
    console.log('serviceLevelServices sls1', this.serviceLevelServices);
  }

  getPageOfFamilies($event, fromEdited? : boolean) {
    console.log('enter page of families');
    this.store.dispatch(new ClearPageOfFamilies());
    this.families = [];
    this.eventForm.controls.familyIdentifier.setValue(undefined);
    let search : string = this.eventForm.value.familySearchIdentifier;
    console.log('getPageOfFamilies', search);
    if (search && search.length > 3) {
      const action : GetPageOfFamilies = new GetPageOfFamilies(0, 50, '', search, '', 'asc');
      // console.log('GetPageOfFamilies', 'dispatch', $event, action);
      this.store.dispatch(action).subscribe(() => {
        const familyPage : FamilyPage = this.familyStore.getCurrentPage();
        if (familyPage) {

          this.families = familyPage.content;
          if (fromEdited && this.families.length > 0) {
            this.eventForm.controls.familyIdentifier.setValue(this.families[0].identifier);
            this.family = this.families[0];
            console.log(this.family, this.serviceLevels);
            this.setServices();
            console.log('Got family sls2',this.family, this.serviceLevelServices);
          }
          console.log('Got families',this.families);
        }
      });
    }
  }

  setServices() {
    console.log('setServices', this.family.serviceLevel, this.serviceLevels, this.getServiceLevel(this.family.serviceLevel));
    const serviceLevelSkill : ServiceLevelServices = this.getServiceLevel(this.family.serviceLevel);
    this.serviceLevelServices = [];
    if (serviceLevelSkill?.serviceLevel?.services)
      this.serviceLevelServices = [].concat(serviceLevelSkill.serviceLevel.services.map(s => s.name));
  }

  getServiceLevel(serviceLevel : number | string) : ServiceLevelServices {
    let ret : ServiceLevelServices = undefined;
    // console.log(this.serviceLevels, serviceLevel);
    if (this.serviceLevels) {
      ret = this.serviceLevels.find(s => (s.serviceLevel.id === serviceLevel || s.serviceLevel.name == serviceLevel));
    }
    return ret;
  }

  getServicesForChecklist() : ServiceLevelService[] {
    let ret: ServiceLevelService[] = [];
    if (this.serviceLevels) {
      for (let serviceLevel of this.serviceLevels) {
        ret = ret.concat(serviceLevel.services);
      }
    }
    return ret;
  }

  getServiceNameForId(serviceId : number) {
    let ret : string = '';
    const service : ServiceLevelService = this.getServicesForChecklist().find(s => s.id === serviceId);
    if (service) {
      ret = service.name;
    }
    return ret;
  }

  getCandidates() {
    this.panel = EditCalendarEventDialog.CANDIDATES_PANEL;
    let start : Date = this.eventForm.value.startDt;
    let end : Date = this.eventForm.value.endDt ;
    const startSecs = this.getAdjustedEpochSecs(start);
    const endSecs = this.getAdjustedEpochSecs(end);
    const servicesRequiredNames = this.eventForm.value.servicesRequired.map(s => s.name);
    // console.log('getCandidates', this.currentTeam.teamId, startSecs, endSecs, servicesRequiredNames);
    this.store.dispatch(new GetCandidateAppointments(this.currentTeam.teamId, startSecs, endSecs, servicesRequiredNames)).subscribe(allState => {
     this.candidates = this.schedulingStateStore.getCandidateAppointments()
    //  console.log('Candidates: ', this.candidates);
    });
  }

  canGetCandidates() {
    return this.eventForm.value.startDt && this.eventForm.value.endDt && this.eventForm.value.servicesRequired && this.eventForm.value.servicesRequired.length > 0;
  }

  toAppointmentFormat(startSecs : number, endSecs : number) : string {


    const startDate : Date = new Date(startSecs * 1000);
    const endDate : Date = new Date(endSecs  * 1000);
    // console.log( (startSecs / 86400), startDate, endDate);
    return format(startDate, 'MMM dd, yyyy @ h:mm a') + '-' + format(endDate, ' h:mm a');
  }

  canReschedule() : boolean {
    return  this.isRequestedStatus();
  }

  getTeamMemberNameFromId(teamMemberId : number) {
    const teamMember : TeamMember = this.currentMembers.find(tm => tm.id === teamMemberId);
    if (teamMember) {
      return teamMember.email;
    }
    return 'not found';
  }

  showBaseInformation() {
    this.panel = EditCalendarEventDialog.BASICS_PANEL;
  }

  showTrackProgress() {
    this.panel = EditCalendarEventDialog.PROGRESS_PANEL;
  }

  setTab(index :number) {
    this.tabIndex = index;
    this.setFromCache(this.cachedEvents[index]);
  }

  importChecklistTemplate() {
   console.log('Entering importChecklistTemplate', this.eventForm.value.checklistTemplate, this.currentChecklistItems);
   if (this.eventForm.value.checklistTemplate) {
    const ctId : number = this.eventForm.value.checklistTemplate;
    let checklistTemplate : ChecklistTemplate = this.checklistTemplates.find(ct => ct.id === ctId);
    let checklistItems : ChecklistItem[] = checklistTemplate.items.map(cti => ({
      id : null,
      checklistId : null,
      serviceId : cti.serviceId,
      required: cti.required,
      item : cti.item,
      sourceCTIId: cti.id
    }));
    this.currentChecklistItems = this.currentChecklistItems.concat(checklistItems);
    console.log(this.currentChecklistItems);
    this.checklistItemRows=new UntypedFormArray([]);
    for (let cli of this.currentChecklistItems) {
      this.addChecklistItemRow(cli);
    }
    this.table.renderRows();
    console.log('exiting importChecklistTemplate');
   }

  }

  addChecklistItemRow(checklistItem : ChecklistItem) {
    const group = new UntypedFormGroup({});
    group.addControl('id', new UntypedFormControl(checklistItem.id));
    group.addControl('item', new UntypedFormControl(checklistItem.item));
    group.addControl('required', new UntypedFormControl(checklistItem.required));
    const service : number = checklistItem.serviceId ? checklistItem.serviceId : 0;
    group.addControl('service', new UntypedFormControl(service));
    const workerScore = checklistItem.workerScore ? checklistItem.workerScore : 0;
    group.addControl('workerScore', new UntypedFormControl(workerScore));
    group.addControl('workerNotes', new UntypedFormControl(checklistItem.workerNotes));
    const managerScore = checklistItem.managerScore ? checklistItem.managerScore : 0;
    group.addControl('coordScore', new UntypedFormControl(managerScore));
    group.addControl('coordNotes', new UntypedFormControl(checklistItem.managerNotes));
    group.addControl('sourceCTIId', new UntypedFormControl(checklistItem.sourceCTIId));
    this.checklistItemRows.push(group);
  }

  get checklistItems() {
    return this.checklistItemRows.controls as UntypedFormGroup[];
  }

  getControl(index:number,name:string)
  {
    return this.checklistItemRows.at(index).get(name) as UntypedFormControl
  }



  createFromCandidate(candidates : CandidateSet) {
    // console.log('createFromCandidate, events before: ', this.cachedEvents);
    this.cachedEvents = candidates.appointments.map(appointment => {
      appointment.familyIdentifier = this.eventForm.value.familyIdentifier;
      appointment.familyId = this.family.id;
      appointment.familyIdentifier = this.family.identifier;
      appointment.familyPrimary = this.family.namedPrimary;
      appointment.notes = this.eventForm.value.notes;
      appointment.description = this.eventForm.value.description;
      appointment.status = this.eventForm.value.status;
      let cachedEvent : CachedEvent = {
        eventType : 'Appointment',
        appointment: appointment,
        allDay : false
      };
      return cachedEvent;
    });
    console.log('createFromCandidate, events after: ', this.cachedEvents);
    this.setFromCache(this.cachedEvents[0]);
    this.setTab(0);
    this.panel = EditCalendarEventDialog.BASICS_PANEL;
  }

  getTotalScore() : number {
   let ret : number = 0; this
   for (let i = 0; i <  this.checklistItems.length; i++) {
    if (this.checklistItems[i].value.required) {
      let value : number = this.checklistItems[i].value.workerScore;
      if (value) {
        ret += value;
      }
    }
   }
   return ret;
  }

  getTotalPossible() : number {
    let ret : number = 0; this
    for (let i = 0; i <  this.checklistItems.length; i++) {
     if (this.checklistItems[i].value.required) {
      ret += 10;
     }
    }
    return ret;
  }

  getCoordTotalScore() : number {
    let ret : number = 0; this
    for (let i = 0; i <  this.checklistItems.length; i++) {
     if (this.checklistItems[i].value.required) {
       let value : number = this.checklistItems[i].value.coordScore;
       if (value) {
         ret += value;
       }
     }
    }
    return ret;
  }



}

export interface CachedEvent {
  eventType : string;
  appointment : Appointment;
  allDay? : boolean;
}
